import { render, staticRenderFns } from "./Shfw.vue?vue&type=template&id=5135e55a&scoped=true"
import script from "./Shfw.vue?vue&type=script&lang=js"
export * from "./Shfw.vue?vue&type=script&lang=js"
import style0 from "./Shfw.vue?vue&type=style&index=0&id=5135e55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5135e55a",
  null
  
)

export default component.exports